import React from 'react'
import { InfoTooltip } from '../../../components'
import { WemoloTypography } from '../../../components/Wemolo'
import styles from './SectionBlock.module.css'

interface SectionBlockProps {
    label: string
    caption?: string
    children: React.ReactNode
    last?: boolean
}

export const SectionBlock: React.FC<SectionBlockProps> = ({ label, caption, children, last }) => {
    return (
        <div className={styles.section}>
            <div className={styles.header}>
                <div className={styles.label}>
                    <WemoloTypography variant="title-medium" tag="span">
                        {label}
                    </WemoloTypography>
                </div>

                {caption && <InfoTooltip content={<div>{caption}</div>} />}
            </div>

            <div>{children}</div>
            {!last && <hr className={styles.divider} />}
        </div>
    )
}
